import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import UnderConstruction from "../../public/pages/UnderConstruction";
import RolePageLayout from "./RolePageLayout";
import { ROLE_SHELL_ROUTES } from "./roleShellConfig";

export function RoleShellRoutes() {
  return ROLE_SHELL_ROUTES.map(
    ({
      basePath,
      roleSlug,
      logoutPath,
      dashboard: Dashboard,
      redirects = [],
      extraRoutes = [],
    }) => (
      <Route
        key={basePath}
        path={`/${basePath}`}
        element={
          <RolePageLayout
            requiredRoleSlug={roleSlug}
            logoutPath={logoutPath}
          />
        }
      >
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        {redirects.map(({ from, to }) => (
          <Route
            key={from}
            path={from}
            element={<Navigate to={to} replace />}
          />
        ))}
        {extraRoutes.map(({ path, element: Screen }) => (
          <Route key={path} path={path} element={<Screen />} />
        ))}
        <Route path="*" element={<UnderConstruction />} />
      </Route>
    ),
  );
}
